import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyArNHwzfVMJDkqswqIQbiy6oh7t4XgDguY',
  authDomain: 'britcard-runner.firebaseapp.com',
  projectId: 'britcard-runner',
  storageBucket: 'britcard-runner.firebasestorage.app',
  messagingSenderId: '649442703745',
  appId: '1:649442703745:web:853a2065e61915d7a79080',
  measurementId: 'G-E9C8WK49QW',
}

// Initialize Firebase
console.log('Initializing Firebase...')
const app = initializeApp(firebaseConfig)
console.log('Firebase initialized successfully')

// Initialize Firestore
export const db = getFirestore(app)
console.log('Firestore initialized:', db)
